import { useState } from 'react';

export const useSurgeonDrawerState = () => {
  const [selected, setSelected] = useState<string | null>(null);

  return {
    selectedRegionName: selected ?? null,
    open: (regionName: string) => setSelected(regionName),
    close: () => setSelected(null),
  };
};
